import { useApolloClient } from '@apollo/client/react';
import { useCallback } from 'react';

const HISTORY_QUERY_NAME = 'GetWorkContainerHistory';

// Refreshes an open Change Log without blocking the caller. Unlike a named `refetchQueries`
// entry, it stays quiet when no Change Log is mounted.
export const useRefetchWorkContainerHistory = () => {
  const client = useApolloClient();

  return useCallback(() => {
    client
      .refetchQueries({
        include: 'active',
        onQueryUpdated: (observableQuery) => observableQuery.queryName === HISTORY_QUERY_NAME,
      })
      // A failed refetch shows on the Change Log's own query; this only avoids an unhandled rejection.
      .catch(() => {});
  }, [client]);
};
